export default __webpack_public_path__ + "static/media/breeding-image-disable.211e5b37.png";